<template lang="pug">
.md-card
    md-card-content
        md-field(:class="{'md-invalid': errors.has('horse')}" md-clearable)
            md-icon(md-src="/static/img/horse.svg")
            label {{$t('label.paard')}}
            md-input(v-model="horse.name" required v-autofocus="true" :data-vv-as="$t('label.paard') | lowercase" data-vv-name="horse" v-validate.initial="'required'")
            span.md-error(v-show="errors.has('horse')") {{ errors.first('horse') }}
        md-field(md-clearable)
            md-icon person
            label {{$t('label.eigenaar')}}
            md-input(v-model="owner.name")
        md-field(:class="{'md-invalid': errors.has('email')}" md-clearable)
            md-icon email
            label {{$t('label.email')}}
            md-input(v-model="owner.email" required autocomplete="on" placeholder="john.doe@mycompany.com" type="email" :data-vv-as="$t('label.email')" data-vv-name="email" v-validate.initial="'required|email'" data-vv-delay="200")
            span.md-error(v-show="errors.has('email')") {{ errors.first('email') }}
        md-field(md-clearable)
            md-icon phone
            label {{$t('label.phone')}}
            md-input(v-model="owner.phone")
        md-checkbox.md-primary(v-model="acceptTerms")
        span(v-html="accepting")
        md-card-actions
            md-button#action.md-flat.md-accent(@click="clearData") {{$t('label.reset')}}
            span(style="flex:1;")
            md-button.md-raised.md-primary(:disabled="!formValidated" @click="setData" style="color: #012C58;") {{$t('label.next')}}
</template>
<script>
import { mapFields } from 'vee-validate'
import { mapState } from 'vuex'
import { ACCEPT_TERMS, SET_USER, SET_HORSE } from '@/constants/store'
export default {
  data: () => ({
    acceptTerms: true,
    horse: { name: '', weight: 0 },
    owner: { name: '', email: '', phone: '' }
  }),
  created () {
    this.horse = this.savedHorse
    this.owner = this.savedOwner
    this.acceptTerms = this.storedAcceptance
  },
  watch: {
    acceptTerms () {
      this.$store.commit(ACCEPT_TERMS, this.acceptTerms)
    }
  },
  computed: {
    ...mapState({
      savedOwner: 'user',
      savedHorse: 'horse',
      storedAcceptance: 'acceptTerms',
      language: 'language',
      langTag: state => state.activecampaign.langTag
    }),
    ...mapFields({
      horseName: 'horse',
      mail: 'email'
    }),
    accepting () {
      return this.$t('label.acceptTerms')
    },
    formValidated () {
      return this.acceptTerms && Object.keys(this.fields).every(key => this.fields[key].validated) && Object.keys(this.fields).every(key => this.fields[key].valid)
    }
  },
  methods: {
    async setData () {
      this.$store.dispatch('registerUser', this.owner)
      await this.$store.commit(SET_USER, this.owner)
      await this.$store.commit(SET_HORSE, this.horse)
      await this.logAC()
      this.$emit('next', true)
    },
    /**
     *  Insert ActiveCampaign tag generation here
     *  - create contact if not exists for email
     *  - store contactID for later use
     *  - add mycavalor tag to user
     */
    async logAC () {
      // console.log('Logging to ActiveCampaign')
      let contact = await this.$store.dispatch('activecampaign/getUserByEmail', this.owner)
      // console.log(`Check for existing user ${this.owner.email} returns ${contact}`)
      if (contact === undefined) {
        // console.log('Contact does not exist - Create one')
        contact = await this.$store.dispatch('activecampaign/createUser', this.owner)
      }
      // console.log(`Contact to use: ${contact}`)
      const { id } = contact
      // add to 'mycavalor-tool' list - should only be done once but doesn't return error
      this.$store.dispatch('activecampaign/addToMyCavalorList', contact)
      // console.log(`Contact: ${contact} with id: ${id}`)
      // add language tag to contact id
      const lang = this.langTag[this.language]
      // const ltag =
      await this.$store.dispatch('activecampaign/addTag', { contactTag: { contact: id, tag: lang } })
      // console.log(`Language Tag added to ${id} - ${ltag}`)
      // add mycavalor tag to contact id
      // const tag =
      await this.$store.dispatch('activecampaign/addTag', { contactTag: { contact: id, tag: 112 } })
      // console.log(`Tag added to ${id} - ${tag}`)
    },
    clearData () {
      this.horse.name = ''
      this.owner.name = ''
      this.owner.email = ''
      this.owner.phone = ''
      this.$emit('reset', true)
    }
  }
}
</script>
<style scoped>
.md-card {
    background-color: white;
    margin: 0px;
}
button#action:hover {
  border-width: 1px;
  border-color: #012c58;
  border-style: solid;
}
</style>



// WEBPACK FOOTER //
// src/components/DataCard.vue